<template>
  <div>
    <CertificateVertical v-if="mode === 'vertical'" />
    <CertificateHorizontal v-else />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import CertificateVertical from '../../../components/mooc/issuanceOfCertificate/CertificateVertical.vue'
import CertificateHorizontal from '../../../components/mooc/issuanceOfCertificate/CertificateHorizontal.vue'

export default {
  page: {
    title: 'چاپ مدارک',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-print-licenses',
  components: { CertificateVertical, CertificateHorizontal },
  data() {
    return {
      mode: this.$route.params.type,
    }
  },
}
</script>
